import { useMemo } from 'react';

import { useMy } from '@/hooks/useMy';
import { ScanProfile } from '@/types/scanProfile';

export function useScanProfiles(email?: string) {
  const { data: settings } = useMy(
    { resource: 'setting' },
    email ? { email } : undefined
  );

  const profiles = useMemo(() => {
    const setting = settings?.find(s => s.name === 'scan-profiles');
    return (setting?.value as ScanProfile[] | undefined) ?? [];
  }, [settings]);

  return { profiles };
}
